import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { downloadExcel } from '~/functions/export';
import { useExportReviewImpactDataLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ExportReviewImpactExcel',
  props: {
    requestId: null,
    ventures: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var showExportDialog = ref(false);
    var selectedExportVentureIds = ref([]);
    var _useExportReviewImpac = useExportReviewImpactDataLazyQuery({
        input: {
          reviewRequestId: props.requestId,
          ventureIds: []
        }
      }, {
        fetchPolicy: 'network-only'
      }),
      load = _useExportReviewImpac.load,
      refetch = _useExportReviewImpac.refetch,
      loading = _useExportReviewImpac.loading;
    var emitUserMessage = function emitUserMessage(type, message, color) {
      window.$nuxt.$emit(type, _objectSpread({
        message: message
      }, color ? {
        color: color
      } : {}));
    };
    var buildExportVariables = function buildExportVariables() {
      return {
        input: {
          reviewRequestId: props.requestId,
          ventureIds: _toConsumableArray(selectedExportVentureIds.value)
        }
      };
    };
    var finishExport = function finishExport(data) {
      var file = data === null || data === void 0 ? void 0 : data.exportReviewImpactData;
      if (!(file !== null && file !== void 0 && file.base64String)) {
        emitUserMessage('userError', proxy.$t('exportFailed'));
        return;
      }
      downloadExcel(file.base64String, file.fileName);
      emitUserMessage('userMsg', proxy.$t('exportDone'), 'green');
      showExportDialog.value = false;
    };
    var selectAllVentures = function selectAllVentures() {
      selectedExportVentureIds.value = props.ventures.map(function (venture) {
        return venture.ventureId;
      });
    };
    var clearSelectedVentures = function clearSelectedVentures() {
      selectedExportVentureIds.value = [];
    };
    var toggleVentureSelection = function toggleVentureSelection(ventureId) {
      if (selectedExportVentureIds.value.includes(ventureId)) {
        selectedExportVentureIds.value = selectedExportVentureIds.value.filter(function (id) {
          return id !== ventureId;
        });
        return;
      }
      selectedExportVentureIds.value = [].concat(_toConsumableArray(selectedExportVentureIds.value), [ventureId]);
    };
    var openExportDialog = function openExportDialog() {
      selectedExportVentureIds.value = props.ventures.map(function (venture) {
        return venture.ventureId;
      });
      showExportDialog.value = true;
    };
    var closeExportDialog = function closeExportDialog() {
      showExportDialog.value = false;
    };
    var startExport = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var variables, loadResult, refetchResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (selectedExportVentureIds.value.length) {
                _context.next = 3;
                break;
              }
              emitUserMessage('userError', proxy.$t('exportNoSelection'));
              return _context.abrupt("return");
            case 3:
              variables = buildExportVariables();
              _context.prev = 4;
              loadResult = load(null, variables);
              if (!(loadResult instanceof Promise)) {
                _context.next = 13;
                break;
              }
              _context.t0 = finishExport;
              _context.next = 10;
              return loadResult;
            case 10:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);
              return _context.abrupt("return");
            case 13:
              _context.next = 15;
              return refetch(variables);
            case 15:
              refetchResult = _context.sent;
              finishExport(refetchResult === null || refetchResult === void 0 ? void 0 : refetchResult.data);
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t2 = _context["catch"](4);
              emitUserMessage('userError', proxy.$t('exportFailed'));
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 19]]);
      }));
      return function startExport() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      showExportDialog: showExportDialog,
      selectedExportVentureIds: selectedExportVentureIds,
      load: load,
      refetch: refetch,
      loading: loading,
      emitUserMessage: emitUserMessage,
      buildExportVariables: buildExportVariables,
      finishExport: finishExport,
      selectAllVentures: selectAllVentures,
      clearSelectedVentures: clearSelectedVentures,
      toggleVentureSelection: toggleVentureSelection,
      openExportDialog: openExportDialog,
      closeExportDialog: closeExportDialog,
      startExport: startExport
    };
  }
});